import { topicItems } from '@/mocks/homeData';

export default function SectionTopics() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="topics" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            看看大家都在讨论什么，发现你的下一部心头好
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4 max-w-4xl mx-auto">
          {topicItems.map((topic) => (
            <a
              key={topic.label}
              href={topic.href}
              onClick={(e) => handleClick(e, topic.href)}
              className={`group flex items-center gap-2 px-4 py-2.5 md:px-5 md:py-3 rounded-full border transition-all duration-200 cursor-pointer whitespace-nowrap ${
                topic.hot
                  ? 'bg-primary-50 border-primary-200 hover:bg-primary-100'
                  : 'bg-background-50 border-background-200/70 hover:border-primary-300 hover:bg-background-100'
              }`}
            >
              {topic.hot && (
                <span className="w-2 h-2 rounded-full bg-primary-500 flex-shrink-0"></span>
              )}
              <span className={`text-sm md:text-base font-medium whitespace-nowrap ${
                topic.hot ? 'text-primary-700' : 'text-foreground-700'
              }`}>
                {topic.label}
              </span>
              <span className="text-xs text-foreground-400 whitespace-nowrap">
                {topic.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}